import { render, staticRenderFns } from "./DmAnlageDetail.vue?vue&type=template&id=006f5380&scoped=true&"
import script from "./DmAnlageDetail.vue?vue&type=script&lang=js&"
export * from "./DmAnlageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f5380",
  null
  
)

export default component.exports